export default class RadyolojiKabulAramaKriterleri {
    baslangicTarih?: string = null;
    bitisTarih?: string = null;
    servisId?: number = null;
    kurumId?: number = null;
    kimlikId?: number = null;
    cekimDurum?: number = 1;
    sorguDurum?:string = "1";
    raporTipTanimId: number;
    redGetir:boolean=false;
    randevuGetir:string="H";
    acil:string="H";
}